import * as React from "react";
import Modul from 'diy/module/Modul';

import SyncPosition, {PositionBox} from "diy/components/SyncPosition";
import CircularProgress from "material-ui/CircularProgress";
import diyLightTheme = require("../../material-ui/diyLightTheme");
import Mask from "diy/components/Mask";
import Delayed from "diy/components/Delayed";

export interface ModuleLoadingMasksProps {
    moduleIds: number[];
}

export class ModuleLoadingMasks extends React.Component<ModuleLoadingMasksProps, {}> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    getModule(moduleId: number) {
        return Modul.getInstance(moduleId);
    }

    getModuleEl(moduleId: number): JQuery {
        if (this.getModule(moduleId)) {
            return this.getModule(moduleId).modul;
        }
        return undefined;
    }

    render() {
        let delayAppearance = 250; // if it takes less than 250ms, don't display loading mask
        return (
            <div>
            {
                this.props.moduleIds.map(moduleId => (
                <SyncPosition element={this.getModuleEl(moduleId)[0]} key={moduleId}>
                    {
                        (box: PositionBox) => <Delayed delay={delayAppearance}>
                            <div data-test-id={"module-loading-mask-" + moduleId} style={{
                                width: box.width,
                                height: box.height,
                                left: box.left,
                                top: box.top,
                                position: 'absolute',
                                zIndex: 201 // the old zIndex of the loadingMask
                            }}>
                                <Mask backgroundColor={"rgba(255, 255, 255, 0.7)"}>
                                    <CircularProgress mode="indeterminate" size={0.5} />
                                </Mask>
                            </div>
                        </Delayed>
                    }
                </SyncPosition>
                )
                )}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/ModuleLoadingMasks.tsx
 **/